import React from "react";
import { Divider } from "@material-ui/core";
import styled from "styled-components";
import stringHumanize from "string-humanize";
import Typography from "../../../elements/v2/Typography/Typography";
import { useSearchPageContext } from "../SearchPageContext";
import { DepartmentFilter } from "../../../../utils/algolia/refinements/DepartmentFilter";
import MobileFiltersWrapper from "./MobileFiltersWrapper";
import ChipFilter from "../../../../utils/algolia/refinements/ChipFilter";
import CategoryFilter from "../../../../utils/algolia/refinements/CategoryFilter";
import BrandFilter from "../../../../utils/algolia/refinements/BrandFilter";
import ChipGroupFilter from "../../../../utils/algolia/refinements/ChipGroupFilter";
import ColourFilter from "../../../../utils/algolia/refinements/ColourFilter";
import PriceFilter from "../../../../utils/algolia/refinements/PriceFilter";
import SizeFilter from "../../../../utils/algolia/refinements/SizeFilter";
import SwitchFilter from "../../../../utils/algolia/refinements/SwitchFilter";

export function humanizeDealsLabel(label: string) {
  return label.replace(/\|/, " ");
}

function SearchFilters() {
  const { collectionId, categories, isProfilePage } = useSearchPageContext();
  const showDepartmentFilter = !collectionId && !isProfilePage;

  return (
    <MobileFiltersWrapper>
      <div className="t-searchFilters">
        <Text>Filter</Text>
        <Divider variant="middle" component="p" />
        {showDepartmentFilter && <DepartmentFilter />}
        <CategoryFilter categories={categories} />
        <BrandFilter />
        <SizeFilter />
        <ChipFilter label="Length" attribute="length" />
        <ColourFilter />
        <ChipFilter label="Pattern" attribute="pattern" />
        <PriceFilter />
        <ChipFilter
          label="Deals"
          attribute="price_reduced_percentage_bucket"
          labelRender={humanizeDealsLabel}
        />
        <ChipFilter label="Buy/Rent" attribute="item_type" />
        <ChipFilter label="Condition" attribute="condition" labelRender={stringHumanize} />
        <SwitchFilter label="Adaptive" attribute="adaptive" />
        <ChipFilter label="Comes with" attribute="comes_with" />
        <ChipGroupFilter label="Material" attribute="material" />
        <ChipFilter label="Occasion" attribute="occasion" />
        <ChipGroupFilter label="Style" attribute="style" />
      </div>
    </MobileFiltersWrapper>
  );
}

export default SearchFilters;

const Text = styled(Typography)`
  font-size: 9px;
  margin-left: 16px;
  color: #555555;
  text-transform: uppercase;
  margin-bottom: 1rem;
`;
